import { Solicitacao as NovaSolicitacao, CrendencialModel, PortfolioSolicitadoModel } from "./solicitacao-pni";

export class FormasIntegracao {

  noFormaIntegracao: string;

}

export class OperadorCadsus {

  dsEmail: string;
  noArea: string;
  noSetor: string;
  nuCnes: string;
  nuCns: number | string;
  nuDdd: number | string;
  nuTelefone: string;
  nuCpf: string;
  noOperadorCadsus: string;

}

export class PeriodoAcesso {

  dtFim: string;
  dtInicio: string;
  periodoMaiorAcesso: string;

}

export class Servico {

  dtFimPicoAcesso: Date;
  dtInicioPicoAcesso: Date;
  noOperacao: string;
  noServico: string;
  qtAcessoPeriodoPico: number;
  qtMaxDia: number;
  qtMinDia: number;

}

export class SistemasIntegrado {

  noSistemaIntegracao: string;

}

export class Sistema {

  dsArquitetura: string;
  dsSistemaSolicitante: string;
  dtMes: Date;
  formasIntegracao: FormasIntegracao[];
  noBancoDeDados: string;
  noEmpresa: string;
  noLinguagem: string;
  noOutros: string;
  noSistemaSolicitante: string;
  nuIpFinal: string;
  nuIpInicial: string;
  nuVersao: string;
  nuVersaoBanco: string;
  operadorCadsus: OperadorCadsus;
  periodoAcesso: PeriodoAcesso[];
  qtAtendimento: string;
  servicos: Servico[];
  sistemasIntegrados: SistemasIntegrado[];
  stAplicacaoWeb: string;
  stEmpresaPrivada: string;
  periodoAcessoModel: PeriodoAcesso[];

  constructor() {
    this.operadorCadsus = new OperadorCadsus();
    this.formasIntegracao = [];
    this.sistemasIntegrados = [];
    this.periodoAcessoModel = [];
  }

}

export class FormResponsavel {

  nomeArea: any;
  localArea: any;
  siglaArea: any;
  nuCnes: any;
  nuCnpj: any;
  noRazaoSocial: any;
  noFantasia: any;
  nuTelefone: any;
  dsEmail: any;
  nuCep: any;
  sgUf: any;
  nuIbgeMunicipio: any;
  dsBairro: any;
  dsEndereco: any;
  dsComplemento: any;
  nomeGestor: any;
  cpfGestor: any;
  nuCns: any;
  telfoneGestor: any;
  emailGestor: any;
  cnes: number;
  cns: number;
  razaoSocial: any;
  dsLocalArea: string;
  noArea: string;
  sgArea: string;
  nuDdd: number;

}

export class Solicitante {

  cnes: number;
  cns: string;
  dsLocalArea: string;
  noArea: string;
  sgArea: string;
  dsEmail: string;
  noFantasia: string;
  noRazaoSocial: string;
  nuDdd: any;
  nuTelefone: any;
  nuCnpj: string;
  dsComplemento: string;
}

export class Solicitacao {

  formResponsavel?: FormResponsavel;
  noUsuario?: string;
  sistema: Sistema;
  solicitante: Solicitante;
  update: boolean;
  // Variaveis de controle interno
  idRascunho?: number;
  concluida?: boolean;
  isInterno?: boolean;
  nuAno?: number;
  nuCnpj: string;
  nuCnes: string;
  nuSolicitacao?: number;
  estabelecimentosFilhos: any;
  credencialModel: CrendencialModel;
  credencial: CrendencialModel;
  periodoAcessoModel: any;
  portfolioSolicitadoModel: PortfolioSolicitadoModel;


  constructor() {
    Object.setPrototypeOf(this, Solicitacao.prototype);
    this.sistema = new Sistema();
    this.solicitante = new Solicitante();
    return this
  }

}

export interface ResponseSolicitacao {

  mensagens: Array<string>;
  nuAno: number;
  nuSolicitacao: number;
  sucesso: boolean;

}

export class AbasEvent {

  nomeAba: string;
  paginaAtual: number;
  totalPage: number;
  proximaAba: boolean;
  abaAnterior: boolean;

}

export type SolicitacaoType = Solicitacao | NovaSolicitacao



// WEBPACK FOOTER //
// ./src/app/model/solicitacao.ts